/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';
import { IldsFooterProps } from '../lds-footer.data';

// @ts-ignore
import { Text5 } from '@churchofjesuschrist/eden-text';

const SiteLinks: React.FC<IldsFooterProps> = ({ Links }) => {
    const contactUs = Links ? Links.contactLink : '';
    const help = Links ? Links.helpLink : '';
    const storeLocator = Links ? Links.storeLocator : '';
    const feedback = Links ? Links.feedbackLink : '';

    return (
        <div className='siteLinks'>
            <a
                className='siteLink'
                style={{ paddingLeft: '0px' }}
                href={contactUs && contactUs.linkUrl ? contactUs.linkUrl.destinationUrl : ''}
            >
                <Text5>{contactUs && contactUs.linkText ? contactUs.linkText : 'Contact Us'}</Text5>
            </a>
            <a className='siteLink' href={storeLocator && storeLocator.linkUrl ? storeLocator.linkUrl.destinationUrl : ''}>
                <Text5>{storeLocator && storeLocator.linkText ? storeLocator.linkText : 'Store Locator'}</Text5>
            </a>
            <a className='siteLink' href={help && help.linkUrl ? help.linkUrl.destinationUrl : ''} target='_blank' rel='noreferrer'>
                <Text5>{help && help.linkText ? help.linkText : 'Help'}</Text5>
            </a>
            <a
                className='siteLink'
                href={feedback && feedback.linkUrl ? feedback.linkUrl.destinationUrl : ''}
                target='_blank'
                rel='noreferrer'
            >
                <Text5>{feedback && feedback.linkText ? feedback.linkText : 'Feedback'}</Text5>
            </a>
        </div>
    );
};

export default SiteLinks;
